import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=d979f4fe&scoped=true&"
import script from "./SideBarItem.vue?vue&type=script&lang=js&"
export * from "./SideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=d979f4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d979f4fe",
  null
  
)

export default component.exports